import { render, staticRenderFns } from "./LicenceTable.vue?vue&type=template&id=5b1199a3&scoped=true"
import script from "./LicenceTable.vue?vue&type=script&lang=js"
export * from "./LicenceTable.vue?vue&type=script&lang=js"
import style0 from "./LicenceTable.vue?vue&type=style&index=0&id=5b1199a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1199a3",
  null
  
)

export default component.exports